import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ChipWithTooltip from '../../../Components/ChipWithTooltip';
import { HOW_TO_USE_THIS_DASHBOARD } from '../const';
import InsightsDrawer from './drawer/InsightsDrawer';
import Button from '../../../Components/Buttons/CustomButton';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        height: '100%',
        width: '100%',
        boxShadow: 'none',
        borderColor: 'hsl(219 100 93)',
        borderRadius: '.75rem',
        border: '1px solid',
        padding: theme.spacing(2),
        '& .MuiTypography-h5': {
            marginTop: 0,
            marginBottom: 0
        }
    },
    headerContent: {
        padding: theme.spacing(0, 2),
        justifyContent: 'center',
    },
    cardHeaderContentTitle: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            alignItems: 'flex-start',
            '& .MuiChip-root': {
                margin: `${theme.spacing(1)}px 0px 0px 0px`
            },
        },
    },
    descriptionTitle: {
        fontWeight: 600,
        color: 'gray',
        fontSize: theme.spacing(2),
    },
    metricValue: {
        fontSize: theme.spacing(4),
        fontWeight: 600,
    },
    cardWrapper: {
        backgroundColor: 'rgb(245, 248, 255)',
        padding: '16px'
    },
    exploreButton: {
        fontWeight: 'bold',
        borderRadius: '0.5rem',
    },
}))

const MetricTopCard = (props) => {
    const classes = useStyles()
    const { value, subtitle, description, tooltipTitle, tooltipDescription, helpdocLink, drawerTitle, industryBreakdown, insightsDrawerButtonLink, reviewCount } = props

    const [drawerOpened, setDrawerOpened] = useState(false)

    const toggleDrawer = (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }

        setDrawerOpened(!drawerOpened)
    }

    return (
        <Grid item xs={12}>
            <div className={classes.cardWrapper}>
                <Card className={classes.root}>
                    <CardHeader
                        title={
                            <div className={classes.cardHeaderContentTitle}>
                                <ChipWithTooltip
                                    tooltipDescription={tooltipDescription}
                                    tooltipTitle={tooltipTitle}
                                />
                            </div>
                        }
                        className={classes.headerContent}
                    />
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item md={5} sm={12}>
                                <Grid item sm={12} className={classes.metricValue}>
                                    {value}
                                </Grid>
                                <Grid item sm={11}>
                                    {subtitle}
                                </Grid>
                            </Grid>
                            <Grid item md={7} sm={12}>
                                <Grid item xs={12} className={classes.descriptionTitle}>
                                    {HOW_TO_USE_THIS_DASHBOARD}
                                </Grid>
                                <Grid item xs={12}>
                                    {description}
                                </Grid>
                                <Grid item xs={12}>
                                    <Button color="tertiary" variant="contained" className={classes.exploreButton} onClick={toggleDrawer}>
                                        Explore insights
                                    </Button>
                                    <InsightsDrawer
                                        helpdocLink={helpdocLink}
                                        title={drawerTitle}
                                        drawerOpened={drawerOpened}
                                        toggleDrawer={toggleDrawer}
                                        insightsDrawerButtonLink={insightsDrawerButtonLink}
                                        industryBreakdown={industryBreakdown}
                                        reviewCount={reviewCount}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default (MetricTopCard)
